import React from 'react';
import SearchPage from './SearchPage';
import { fetchSearchPage } from '../../utils/lib';
import ListItemWAvatar from '../../layouts/ListItemWAvatar';
import { Box, CircularProgress } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import { useConfig } from '../../providers/ConfigProvider';
import { useTranslation } from 'react-i18next';

const SearchPet = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const {config, isLoadingConfig} = useConfig();
  const { t } = useTranslation();
  
  const renderItem = (item) => (
    <Box
      sx={{
        width: '100%',
        cursor: 'pointer',
      }}
      onClick={() => handleOnClick(item)}
    >
      <ListItemWAvatar 
        key={item.id} 
        primary={item.name}
        secondary={item.owners_es}
        />
    </Box>
  );

  const handleOnClick = async (pet) => {
    const from = location.state?.from;
    if (from) {
      //navigate(from, { state: { pet } });
      navigate(from, { state: { pet }, replace: true });
    } else {
      //navigate('/main/view-pet', { state: { id: pet.id, updateLastView: true } });
      navigate('/main/view-pet', { state: { id: pet.id, updateLastView: true }, replace: true });
    }
  };

  if (isLoadingConfig) return (
    <>
      <CircularProgress
        size={42}
        sx={{ position: 'absolute', top: '50%', left: '50%', marginTop: '-21px', marginLeft: '-21px' }}
      />
    </>
  );

  return (
    <SearchPage
      fetchFunction={fetchSearchPage}
      table={'pets'}
      renderItem={renderItem}
      placeholder={t('search.searchPet', { name: config.vet.pet_naming_es.toLowerCase() })}
    />
  );
};

export default SearchPet;